import styled from 'styled-components';
import DotIcon from '../../../assets/svg/icons/dot.svg';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 60rem;
  margin: 0 auto;
  padding: 0 2rem;
  font-size: 1rem;

  .primary-button {
    margin-bottom: 4rem;
    font-family: 'MarkPro-Bold';
    font-size: 1rem;
    line-height: 1.27rem;
    width: 100%;
    max-width: 20rem;
    border-radius: 0.55rem;
    padding: 0.77rem 0px;
  }

  @media (max-width: 768px) {
    padding: 0 1.25rem;
  }
`;

export const TextContent = styled.main`
  width: 100%;
  margin: 3rem 0 4rem;

  > .markdown-container {
    h1 {
      font-family: 'MarkPro-Heavy';
      font-size: 1.56rem;
      margin-bottom: 2rem;
    }

    h2 {
      font-family: 'MarkPro-Heavy';
      font-size: 1.44rem;
      margin-bottom: 1.8rem;
    }

    h3 {
      font-family: 'MarkPro-Heavy';
      font-size: 1.33rem;
      margin-bottom: 1.8rem;
    }

    p {
      max-width: 100%;
      font-size: 1.11rem;
      line-height: 1.78rem;
      margin-bottom: 1.5rem;
    }

    strong {
      font-family: 'MarkPro-Heavy';
    }

    a {
      font-family: 'MarkPro-Bold';

      &:hover {
        text-decoration: underline;
      }
    }

    img {
      display: flex;
      max-width: 100%;
      border-radius: 1.11rem;
      margin: 1rem auto;
    }

    ul {
      margin-bottom: 1.5rem;
      padding-left: 0.5rem;
    }

    li {
      background: url(${DotIcon}) no-repeat left 5px;
      padding-left: 1.3rem;
      margin-bottom: 1.3rem;
    }
  }
`;

export const ImageArea = styled.main`
  margin-top: 4rem;

  > img {
    width: 12rem;
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    margin-top: 2.5rem;

    > img {
      width: 9rem;
    }
  }
`;
